module.exports = __webpack_public_path__ + "ad.svg?7bb20e6a5b0ae2dc0b085c42ff7cf68c";